import React from "react"
import { Outlet } from "react-router-dom"
import { useApp } from "../../hooks/useApp"
import { properties } from "../../utils/Properties_es"
import Loading from "../utils/Loading"
import Footer from "./Footer"
import Logo from "../../resources/images/logo-parval.png"
import "../../resources/styles/home.css"
import { CONSTANT } from "../../utils/Constant"
import MessageManager from "../utils/MessageManager"

const HomeLayout = () => {
  const { isLoading, errorMsg, resetErrorMsg, successMsg, resetSuccessMsg } =
    useApp()

  //set tittle
  document.title = "PARVAL | PORTAL EJECUTIVO"
  return (
    <>
      {errorMsg && (
        <MessageManager
          type={CONSTANT.DANGER_MSG}
          msg={errorMsg}
          details=''
          callback={resetErrorMsg}
        />
      )}
      {successMsg && (
        <MessageManager
          type={CONSTANT.SUCCESS_MSG}
          msg={successMsg}
          details=''
          callback={resetSuccessMsg}
        />
      )}
      {isLoading && (
        <Loading title={properties.com_parval_label_loading_title} />
      )}
      <div className='bgr-container pb-3'>
        <div className='container'>
          <div className='logo pt-4 text-center'>
            <div className='rounded-circle m-auto logo-center'>
              <img src={Logo} height='135' alt='' />
            </div>
          </div>
          <Outlet />
        </div>
      </div>
      <Footer footerType='login' />
    </>
  )
}
export default HomeLayout
